// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getRemoteConfig } from "firebase/remote-config";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAP08g4T3AnXAVK3ieuHVho55UCFMZOxzI",
  authDomain: "talzo-9e428.firebaseapp.com",
  databaseURL: "https://talzo-9e428-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "talzo-9e428",
  storageBucket: "talzo-9e428.firebasestorage.app",
  messagingSenderId: "852784719584",
  appId: "1:852784719584:web:1c12ecac1a8b8cde1d9285",
  measurementId: "G-RL56N38NG9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const database = getDatabase(app);
const remoteConfig = getRemoteConfig(app);

export { app, auth, database, remoteConfig, analytics };
export default app;
